export default (state = {}, action) => {
  switch (action.type) {
    default:
      return state
  }
}



// WEBPACK FOOTER //
// src/reducers/home.js